/**
 * Mail sending utilities.
 */
export class UtilsSendMail {
  public static getLinkToSendMail(obj: IParametersForGetLinkToSendMail): string {
    if (!obj) {
      console.warn('please define obj for correctly work');
      return '';
    }

    let result = 'mailto:' + obj.mailTo;
    let cnt = 0;

    if (obj.subject != null) {
      result = result + (cnt++ === 0 ? '?' : '&') + 'subject=' + obj.subject;
    }
    if (obj.body != null) {
      result = result + (cnt++ === 0 ? '?' : '&') + 'body=' + obj.body;
    }
    if (obj.copyAddress != null) {
      result = result + (cnt++ === 0 ? '?' : '&') + 'cc=' + obj.copyAddress;
    }

    return result;
  }
}

export interface IParametersForGetLinkToSendMail {
  mailTo: string;
  subject?: string;
  body?: string;
  copyAddress?: string;
}
